const actions = {
  SET_LANGUAGE: "SET_LANGUAGE",
  SET_MODAL_CONTENTS: "SET_MODAL_CONTENTS",
  SET_MODAL_IMAGE: "SET_MODAL_IMAGE",
  SET_SHOW_MODAL: "SET_SHOW_MODAL",
  SET_MODAL_TYPE: "SET_MODAL_TYPE",
  SET_MODAL_TITLE: "SET_MODAL_TITLE",
  SET_MODAL_AUDIO: "SET_MODAL_AUDIO",
  SET_MODAL_AUDIODESCRIPTION: "SET_MODAL_AUDIODESCRIPTION",
  CLEAR_MODAL: "CLEAR_MODAL",
  SET_HIDE_SIDEBAR: "SET_HIDE_SIDEBAR",
  SET_PATH: "SET_PATH",
  TOGGLE_PLAYBACK: "TOGGLE_PLAYBACK",
  SET_PLAYER_INSTANCE: "SET_PLAYER_INSTANCE",
  SET_AVATAR_MESSAGE: "SET_AVATAR_MESSAGE",
  SET_SLIDER_THEME: "SET_SLIDER_THEME",
  CLOSE_MODALS: "CLOSE_MODALS",
}

export default actions
